// extracted by mini-css-extract-plugin
export default {"page-title":"error_page-title__r2afx","container":"error_container__9yq9j"};